module.exports = (__webpack_require__(232540))(961);